export enum ShippingStatusValueType {
  USED = 'USED',
  SHIPPED = 'SHIPPED',
  UNKNOWN = 'UNKNOWN',
}
